'use client'

import React, { useState, useEffect } from 'react'
import Image from 'next/image'

// Datos de galería - SOLO 24 FOTOS (mismo que GalleryMobileSlider24)
const galleryImages = [
  // 1-4: Google Ads
  { id: 1, category: "Publicidad", description: "Campaña Google Ads 07", image: "/images/optimized/google_ads_airlovers_07-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_07-thumbnail.webp" },
  { id: 2, category: "Publicidad", description: "Campaña Google Ads 08", image: "/images/optimized/google_ads_airlovers_08-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_08-thumbnail.webp" },
  { id: 3, category: "Publicidad", description: "Campaña Google Ads 09", image: "/images/optimized/google_ads_airlovers_09-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_09-thumbnail.webp" },
  { id: 4, category: "Publicidad", description: "Campaña Google Ads 10", image: "/images/optimized/google_ads_airlovers_10-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_10-thumbnail.webp" },
  
  // 5-10: DSC series
  { id: 5, category: "Aventura", description: "Vuelo DSC04706", image: "/images/optimized/DSC04706-gallery.webp", thumbnail: "/images/optimized/DSC04706-thumbnail.webp" },
  { id: 6, category: "Paisajes", description: "Paisaje DSC04656", image: "/images/optimized/DSC04656-gallery.webp", thumbnail: "/images/optimized/DSC04656-thumbnail.webp" },
  { id: 7, category: "Vuelo", description: "Vuelo DSC04659", image: "/images/optimized/DSC04659-gallery.webp", thumbnail: "/images/optimized/DSC04659-thumbnail.webp" },
  { id: 8, category: "Equipo", description: "Equipo DSC04663", image: "/images/optimized/DSC04663-gallery.webp", thumbnail: "/images/optimized/DSC04663-thumbnail.webp" },
  { id: 9, category: "Personas", description: "Clientes DSC04686", image: "/images/optimized/DSC04686-gallery.webp", thumbnail: "/images/optimized/DSC04686-thumbnail.webp" },
  { id: 10, category: "Celebración", description: "Cumpleaños DSC04692", image: "/images/optimized/DSC04692-gallery.webp", thumbnail: "/images/optimized/DSC04692-thumbnail.webp" },
  
  // 11-16: Más fotos (reemplazamos propuestas con hamburguesa y juli)
  { id: 11, category: "Comida", description: "Hamburguesa especial", image: "/images/optimized/hamburguesa_01.webp", thumbnail: "/images/optimized/hamburguesa_01.webp" },
  { id: 12, category: "Personas", description: "Juli disfrutando del vuelo", image: "/images/optimized/juli_01.webp", thumbnail: "/images/optimized/juli_01.webp" },
  { id: 13, category: "Experiencias", description: "Experiencia 3f6bd2cd", image: "/images/optimized/3f6bd2cd-3a64-439b-ba5c-5a6058405389-gallery.webp", thumbnail: "/images/optimized/3f6bd2cd-3a64-439b-ba5c-5a6058405389-thumbnail.webp" },
  { id: 14, category: "Experiencias", description: "Experiencia 801a8e42", image: "/images/optimized/801a8e42-52b6-43b6-936e-8bfaa298aeb6-gallery.webp", thumbnail: "/images/optimized/801a8e42-52b6-43b6-936e-8bfaa298aeb6-thumbnail.webp" },
  { id: 15, category: "Experiencias", description: "Experiencia 91c6ca6e", image: "/images/optimized/91c6ca6e-5ee8-49f4-8214-9378413f07b3-gallery.webp", thumbnail: "/images/optimized/91c6ca6e-5ee8-49f4-8214-9378413f07b3-thumbnail.webp" },
  { id: 16, category: "Paisajes", description: "Paisaje IMG_4762", image: "/images/optimized/IMG_4762-gallery.webp", thumbnail: "/images/optimized/IMG_4762-thumbnail.webp" },
  
  // 17-18: Últimas fotos (volvemos a 18 total)
  { id: 17, category: "Paisajes", description: "Paisaje IMG_4769", image: "/images/optimized/IMG_4769-gallery.webp", thumbnail: "/images/optimized/IMG_4769-thumbnail.webp" },
  { id: 18, category: "Paisajes", description: "Paisaje IMG_4775", image: "/images/optimized/IMG_4775-gallery.webp", thumbnail: "/images/optimized/IMG_4775-thumbnail.webp" }
]

const GalleryGridLightbox24 = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index)
    setLightboxOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const closeLightbox = () => {
    setLightboxOpen(false)
    document.body.style.overflow = 'auto'
  }

  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    )
  }

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    )
  }

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!lightboxOpen) return
      
      switch (e.key) {
        case 'Escape':
          closeLightbox()
          break
        case 'ArrowLeft':
          goToPreviousImage()
          break
        case 'ArrowRight':
          goToNextImage()
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [lightboxOpen])

  return (
    <div className="w-full">
      {/* Grid de galería - 3×4 en desktop (12 fotos visibles) */}
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {galleryImages.map((image, index) => (
          <div 
            key={image.id}
            className="group relative aspect-square overflow-hidden rounded-xl bg-white shadow-lg transition-all duration-300 hover:scale-[1.02] hover:shadow-xl"
            onClick={() => openLightbox(index)}
          >
            <Image
              src={image.thumbnail}
              alt={image.description}
              fill
              className="object-cover transition-transform duration-300 group-hover:scale-105"
              sizes="(max-width: 768px) 50vw, 33vw"
            />
            
            {/* Overlay con información */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <p className="text-sm opacity-90">{image.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
          <button
            onClick={closeLightbox}
            className="absolute right-4 top-4 z-10 rounded-full bg-white/20 p-2 text-white transition-all hover:bg-white/30"
            aria-label="Cerrar lightbox"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <button
            onClick={goToPreviousImage}
            className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-3 text-white transition-all hover:bg-white/30"
            aria-label="Imagen anterior"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <button
            onClick={goToNextImage}
            className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-3 text-white transition-all hover:bg-white/30"
            aria-label="Imagen siguiente"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Imagen */}
          <div className="relative h-full w-full max-w-4xl">
            <Image
              src={galleryImages[currentImageIndex].image}
              alt={galleryImages[currentImageIndex].description}
              fill
              className="object-contain"
              sizes="100vw"
            />
            
            {/* Info */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
              <p className="text-lg">{galleryImages[currentImageIndex].description}</p>
              <p className="mt-2 text-sm opacity-80">
                Imagen {currentImageIndex + 1} de {galleryImages.length}
              </p>
            </div>
          </div>

          {/* Thumbnails */}
          <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 space-x-2 overflow-x-auto py-2">
            {galleryImages.map((image, index) => (
              <button
                key={image.id}
                onClick={() => setCurrentImageIndex(index)}
                className={`relative h-12 w-12 flex-shrink-0 overflow-hidden rounded border-2 ${index === currentImageIndex ? 'border-primary-blue' : 'border-transparent'}`}
              >
                <Image
                  src={image.thumbnail}
                  alt={`Thumbnail ${index + 1}`}
                  fill
                  className="object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default GalleryGridLightbox24